export let MultiBarsProgressBar = [
    {
      main: 1,
      Children: [
        { color: "primary", value: 10 },
        { color: "secondary", value: 10 },
        { color: "success", value: 10 },
        { color: "info", value: 10 },
        { color: "warning", value: 10 },
        { color: "danger", value: 10 },
        { color: "primary", value: 10 },
        { color: "light", value: 10 },
      ],
    },
    {
      main: 2,
      Children: [
        { color: "primary", value: 60 },
        { color: "secondary", value: 20 },
      ],
    },
    {
      main: 3,
      Children: [
        { color: "primary", value: 30 },
        { color: "secondary", value: 60 },
      ],
    },
  ];